import { useNavigate } from "react-router";
import { ChevronRight } from "lucide-react";
import type { GroupedWord } from "../../domain/vocabulary/grouping.ts";
import { navigationForWord } from "../../domain/vocabulary/grouping.ts";
import { groupSubtitle } from "../view-models/labels.ts";
import { TypeTag } from "./TypeTag.tsx";
import styles from "../design-system/ui.module.css";

export function WordRow({ group }: { group: GroupedWord }) {
  const navigate = useNavigate();
  return (
    <button
      className={styles.wordRow}
      type="button"
      onClick={() => {
        const target = navigationForWord(group.meanings);
        if (!target) {
          return;
        }
        if (target.kind === "card") {
          navigate(`/meanings/${target.meaningId}`);
        } else {
          navigate(`/words/${target.wordId}`);
        }
      }}
    >
      <span className={styles.wordBody}>
        <span className={styles.wordTitle}>{group.word.displayText}</span>
        <span className={styles.tags}>
          {group.types.map((type) => (
            <TypeTag key={type} type={type} />
          ))}
        </span>
      </span>
      <span className={styles.rowMeta}>{groupSubtitle(group)}</span>
      <ChevronRight className={styles.chevron} size={22} aria-hidden />
    </button>
  );
}
